import React, { Component } from 'react';
import { Grid, Header, Label, Segment, Tab, Table } from 'semantic-ui-react';
import { LoadingBar, TableForm } from 'components/Commons';
import { connect } from 'react-redux';
import moment from 'moment';

import Constants from 'components/SettlementList/Constants';

import numeral from 'numeral';

class BankDeposit extends Component {
  renderCompanyBankInfoTable = (bankData, tradingInfo) => {
    const { companyBankInfo } = bankData;
    const { companyTrading } = tradingInfo;

    return (
      <Grid>
        <Grid.Row>
          <Grid.Column>
            <Header as="h3">입금 정보</Header>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column width={1} />
          <Grid.Column width={15}>
            <Table celled className="deposit">
              <Table.Body>
                <Table.Row>
                  <Table.Cell rowSpan={4} className="thead" width={4}>
                    입금할 정보
                    <div style={{ marginTop: '5px' }} className="bold">
                      (식권대장)
                    </div>
                  </Table.Cell>
                  <Table.Cell className="thead" width={2}>
                    계좌 번호
                  </Table.Cell>
                  <Table.Cell>
                    {companyBankInfo.accountNo} ({companyBankInfo.bankName})
                  </Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell className="thead first">계좌주명</Table.Cell>
                  <Table.Cell>{companyBankInfo.accountHolder}</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell className="thead first">입금 요청일</Table.Cell>
                  <Table.Cell style={{ fontWeight: 'bold' }}>
                    {moment(companyBankInfo.depositRequestYmd).format('YYYY-MM-DD')}
                  </Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell className="thead first">입금 요청 금액</Table.Cell>
                  <Table.Cell style={{ fontWeight: 'bold' }}>
                    {numeral(companyBankInfo.settleAmt).format('0,0')}
                  </Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell rowSpan={3} className="thead">
                    우리 회사 정보
                    <div style={{ marginTop: '5px' }} className="bold">
                      ({companyTrading.taxGroupName})
                    </div>
                  </Table.Cell>
                  <Table.Cell className="thead first">실제 입금 금액</Table.Cell>
                  <Table.Cell style={{ fontWeight: 'bold' }}>
                    {numeral(companyBankInfo.bankDepositAmt).format('0,0')}
                  </Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell className="thead first">계좌주명</Table.Cell>
                  <Table.Cell>{companyBankInfo.depositor}</Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell className="thead first">기타 사유</Table.Cell>
                  <Table.Cell>{companyBankInfo.bankDepositMemo}</Table.Cell>
                </Table.Row>
              </Table.Body>
            </Table>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  };

  renderBankDepositStatusLabel = (stepProgress, bankDeposit) => {
    let bankDepositLabel;

    const { currentProgressStatus } = stepProgress;
    const { currentProgressDetailStatus } = stepProgress;
    const { bankDepositInfoList } = bankDeposit;

    if (currentProgressStatus === Constants.PROGRESS_STATUS.BANK) {
      if (currentProgressDetailStatus === Constants.BANK_STATUS.PROCESSING) {
        bankDepositLabel = (
          <Grid.Column width="6">
            <Label size="large" color="black" ribbon>
              입금이 되었는지 확인중입니다.
            </Label>
          </Grid.Column>
        );
      } else if (currentProgressDetailStatus === Constants.BANK_STATUS.COMPLETE) {
        bankDepositLabel = (
          <Grid.Column width="6">
            <Label size="large" color="green" ribbon>
              입금이 완료되었습니다.
            </Label>
          </Grid.Column>
        );
      }
    } else if (
      currentProgressStatus === Constants.PROGRESS_STATUS.APPROVAL ||
      currentProgressStatus === Constants.PROGRESS_STATUS.TAX
    ) {
      bankDepositLabel = (
        <Grid.Column width="6">
          <Label size="large" color="black" ribbon>
            아직 은행입금 확인 단계가 아닙니다.
          </Label>
        </Grid.Column>
      );
    } else if (bankDepositInfoList && bankDepositInfoList.length > 0) {
      bankDepositLabel = (
        <Grid.Column width="6">
          <Label size="large" color="green" ribbon>
            입금이 완료되었습니다.
          </Label>
        </Grid.Column>
      );
    }

    return bankDepositLabel;
  };

  renderCompanyBankListTable = (data) => {
    const { bankDepositInfoList } = data;

    const tableList = {
      header: {
        main: [
          { data: '은행', textAlign: 'center' },
          { data: '입금일', textAlign: 'center' },
          { data: '입금금액', textAlign: 'center' },
          { data: '계좌주명', textAlign: 'center' }
        ]
      },
      body: {
        message: '은행 입금 내역이 존재하지 않습니다.'
      }
    };

    if (bankDepositInfoList.length > 0) {
      tableList.body.main = bankDepositInfoList.map((item) => {
        const obj = {
          row: [
            {
              data: item.bankName,
              textAlign: 'center'
            },
            {
              data: moment(item.depositDate).format('YYYY-MM-DD HH:mm'),
              textAlign: 'center'
            },
            {
              data: numeral(item.depositAmt).format('0,0'),
              textAlign: 'right'
            },
            {
              data: item.depositor,
              textAlign: 'center'
            }
          ]
        };
        return obj;
      });
    }

    return <TableForm selectable="true" tabledata={tableList} />;
  };

  render() {
    const { bankData, tradingInfo, stepProgress } = this.props;

    let companyBankInfoTable;
    let bankDepositInfoListTable;
    let bankDepositStatusLabel;
    let loading;

    if (bankData && bankData.data && stepProgress && stepProgress.data && tradingInfo && tradingInfo.data) {
      companyBankInfoTable = this.renderCompanyBankInfoTable(bankData.data, tradingInfo.data);
      bankDepositInfoListTable = this.renderCompanyBankListTable(bankData.data);
      bankDepositStatusLabel = this.renderBankDepositStatusLabel(stepProgress.data, bankData.data);
    } else {
      loading = <LoadingBar />;
    }

    return (
      <div>
        {loading}
        <Tab.Pane style={{ width: 'unset', border: 'none' }}>
          <Grid>
            <Grid.Row style={{ paddingTop: '0px' }}>
              <Grid.Column style={{ paddingLeft: '0px', paddingRight: '0px' }}>
                <Segment>
                  {companyBankInfoTable}
                  <Grid>
                    <Grid.Row>{bankDepositStatusLabel}</Grid.Row>
                    <Grid.Row style={{ paddingTop: '0px' }}>
                      <Grid.Column>
                        <Header as="h3" style={{ marginTop: '7px' }}>
                          입금내역
                        </Header>
                      </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                      <Grid.Column width={1} />
                      <Grid.Column width={15}>{bankDepositInfoListTable}</Grid.Column>
                    </Grid.Row>
                  </Grid>
                </Segment>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Tab.Pane>
      </div>
    );
  }
}

BankDeposit = connect((state) => ({
  bankData: state.settlement.bankDepositDetail,
  stepProgress: state.settlement.progressStatus,
  tradingInfo: state.settlement.tradingInfo
}))(BankDeposit);

export default BankDeposit;
